// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p {
  font-size: 14px;
  font-weight: 500;
  text-transform: none;
}

.wrapper {
  padding: 20px;
  border-radius: 16px;
  text-align: center;
  text-transform: uppercase;
}
.wrapper .cross-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  margin: 0px;
  background: var(--color-white-accent);
  width: 25px;
  height: 25px;
  max-height: 25px;
  max-width: 25px;
  min-height: 25px;
  min-width: 25px;
  padding: 0px;
  z-index: 99;
}
.wrapper .cross-icon ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
.wrapper .cross-icon:hover {
  background: #f2dbd9;
}
.wrapper h3 {
  font-family: AppFontMedium;
  font-size: 16px;
}
.wrapper p {
  font-size: 14px;
  padding: 10px;
}
.wrapper .button-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.wrapper .button-wrapper ion-button {
  margin: 5px;
  min-height: 35px;
}
.wrapper .button-wrapper .sign-up {
  --background: transparent;
  color: var(--color-black);
}
.wrapper .button-wrapper .guest {
  --background: transparent;
  color: var(--color-black);
  --border-width: 0px ;
}

.desc {
  margin-bottom: 40px;
}

.desc-item {
  display: flex;
  align-items: start;
  text-align: start;
  margin-bottom: 10px;
}
.desc-item p {
  padding: 0;
}
.desc-item img {
  margin-right: 10px;
}

ion-button {
  width: 100%;
  margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/ask-to-create-account-modal/ask-to-create-account-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;AACF;;AACA;EACE,aAAA;EAEA,mBAAA;EACA,kBAAA;EACA,yBAAA;AACF;AACE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;AACJ;AACI;EACE,WAAA;EACA,YAAA;EACA,WAAA;AACN;AAEI;EACE,mBAAA;AAAN;AAIE;EACE,0BAAA;EACA,eAAA;AAFJ;AAKE;EACE,eAAA;EACA,aAAA;AAHJ;AAME;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;AAJJ;AAMI;EACE,WAAA;EACA,gBAAA;AAJN;AAOI;EACE,yBAAA;EACA,yBAAA;AALN;AAQI;EACE,yBAAA;EACA,yBAAA;EACA,oBAAA;AANN;;AAUA;EACE,mBAAA;AAPF;;AAUA;EACE,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;AAPF;AAQE;EACE,UAAA;AANJ;AAQE;EACE,kBAAA;AANJ;;AAUA;EACE,WAAA;EACA,mBAAA;AAPF","sourcesContent":["p {\n  font-size: 14px;\n  font-weight: 500;\n  text-transform: none;\n}\n.wrapper {\n  padding: 20px;\n\n  border-radius: 16px;\n  text-align: center;\n  text-transform: uppercase;\n\n  .cross-icon {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    margin: 0px;\n    background: var(--color-white-accent);\n    width: 25px;\n    height: 25px;\n    max-height: 25px;\n    max-width: 25px;\n    min-height: 25px;\n    min-width: 25px;\n    padding: 0px;\n    z-index: 99;\n\n    ion-icon {\n      width: 100%;\n      height: 100%;\n      margin: 0px;\n    }\n\n    &:hover {\n      background: #f2dbd9;\n    }\n  }\n\n  h3 {\n    font-family: AppFontMedium;\n    font-size: 16px;\n  }\n\n  p {\n    font-size: 14px;\n    padding: 10px;\n  }\n\n  .button-wrapper {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n\n    ion-button {\n      margin: 5px;\n      min-height: 35px;\n    }\n\n    .sign-up {\n      --background: transparent;\n      color: var(--color-black);\n    }\n\n    .guest {\n      --background: transparent;\n      color: var(--color-black);\n      --border-width: 0px\n    }\n  }\n}\n.desc {\n  margin-bottom: 40px;\n}\n\n.desc-item {\n  display: flex;\n  align-items: start;\n  text-align: start;\n  margin-bottom: 10px;\n  p {\n    padding: 0;\n  }\n  img {\n    margin-right: 10px;\n  }\n}\n\nion-button {\n  width: 100%;\n  margin-bottom: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
